class PushText extends CardProduct {
  constructor() {
    super();

    this.text = this.querySelector('.js-push-text');
    this.buttons = this.querySelectorAll('.js-push-text-button');

    this.initEvent();
  }

  initEvent() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.text.classList.toggle('--show');
      });
    });
  }
}

if (!customElements.get('push-text')) {
  customElements.define('push-text', PushText);
}
